export const activate = {
  loading: 'Loading',
  insufficientParams: 'Invalid link',
  insufficientParamsPara: 'Missing required parameters',
  setPassword: 'Set user password',
  savePassword: 'Save password',
  goHome: 'Go to Home Page',
  notValidToken: 'Invalid or inactive token',
  alreadyVerified: 'User already activated',
}
